var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account_box" }, [
    _c("div", { staticClass: "title_box" }, [_vm._v("超级补贴订单管理")]),
    _vm._v(" "),
    _c("div", { staticClass: "content_box mt20" }, [
      _c(
        "div",
        { staticClass: "search_criteria" },
        [
          _c("el-input", {
            attrs: { placeholder: "输入订单编号查询", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
            model: {
              value: _vm.queryData.orderNo,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "orderNo", $$v)
              },
              expression: "queryData.orderNo",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "输入商品名称查询", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
            model: {
              value: _vm.queryData.title,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "title", $$v)
              },
              expression: "queryData.title",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "输入商品ID查询", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
            model: {
              value: _vm.queryData.goodsId,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "goodsId", $$v)
              },
              expression: "queryData.goodsId",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "输入用户ID查询", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
            model: {
              value: _vm.queryData.memberId,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "memberId", $$v)
              },
              expression: "queryData.memberId",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { placeholder: "选择商品平台类型", clearable: "" },
              model: {
                value: _vm.queryData.platformCode,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "platformCode", $$v)
                },
                expression: "queryData.platformCode",
              },
            },
            _vm._l(_vm.platformOption, function (item) {
              return _c("el-option", {
                key: item.code,
                attrs: { label: item.name, value: item.code },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { filterable: "", clearable: "", placeholder: "选择活动" },
              model: {
                value: _vm.queryData.activityId,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "activityId", $$v)
                },
                expression: "queryData.activityId",
              },
            },
            _vm._l(_vm.activityOption, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-date-picker", {
            staticClass: "time_picker",
            attrs: {
              "picker-options": _vm.pickerOptions,
              type: "datetimerange",
              "range-separator": "至",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "default-time": ["00:00:00", "23:59:59"],
            },
            on: { change: _vm.onTimeChange },
            model: {
              value: _vm.queryData.timeRange,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "timeRange", $$v)
              },
              expression: "queryData.timeRange",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn_group" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info", plain: "" },
                  on: { click: _vm.onInitialize },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content_box mt20" },
      [
        _c("div", { staticClass: "list_header" }, [
          _c("div", { staticClass: "list_title" }, [_vm._v("订单列表")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "export-btn",
              attrs: { disabled: _vm.exportLoading },
              on: { click: _vm.onExport },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/ExportIcon.png"), alt: "" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("导出")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "header-cell-style": { textAlign: "center" },
              "cell-style": { textAlign: "center" },
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "会员", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "member_name",
                          on: {
                            click: function ($event) {
                              return _vm.onUserDetails(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.memberName))]
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v("UID:" + _vm._s(scope.row.memberId))]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "订单编号", "min-width": "140" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "order_no",
                          on: {
                            click: function ($event) {
                              return _vm.onOrderDetails(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.orderNo))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "商品信息", "min-width": "340" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("GoodsInfoCell", { attrs: { row: scope.row } })]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "实际支付金额",
                prop: "amount",
                "min-width": "110",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "补贴金额",
                prop: "subsidyAmt",
                "min-width": "90",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "佣金", prop: "commission", "min-width": "80" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "商品平台类型", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.platformMapping[scope.row.platformCode] ||
                              scope.row.platformCode
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "所属活动",
                prop: "activityName",
                "min-width": "110",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "用户类型",
                prop: "userTypeName",
                "min-width": "100",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "状态",
                prop: "orderStatusName",
                "min-width": "90",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "创建时间",
                prop: "createTime",
                "min-width": "160",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page_box" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryData.page,
                "page-sizes": [10, 20, 30, 40],
                "page-size": _vm.queryData.size,
                layout: "total, prev, pager, next, sizes, jumper",
                total: _vm.total,
                background: "",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }